import {
  CHANGE_MESSAGE_STATUS,
  DELETE_MESSAGE,
  GET_MESSAGE_LIST,
  GET_NAMES_STORE,
  GET_NEW_MESSAGE_COUNT,
  GET_REPLIES,
  REPLY_MESSAGE,
  SEND_MESSAGES
} from './ApiConstants';
import api from './ApiHandler';

export interface SendMessageRequest {
  page: number;
  limit: number;
  sortDirection?: number;
  sortBy?: string;
}

export const SendMessages = async (payload: any) => {
  return await api.post(SEND_MESSAGES, { ...payload });
};

export const GetMessages = async (payload: any) => {
  return await api.get(GET_MESSAGE_LIST, { params: payload });
};

export const ReplyMessages = async (payload: any) => {
  return await api.post(REPLY_MESSAGE, { ...payload });
};

export const GetReplies = async (payload: any) => {
  return await api.get(GET_REPLIES, { params: payload });
};

export const changeStatus = async (payload: any) => {
  return await api.post(CHANGE_MESSAGE_STATUS, { ...payload });
};

export const fetchNamesList = async (payload: any) => {
  return await api.get(GET_NAMES_STORE, { params: payload });
};

export const deleteMessageById = async (payload: any) => {
  return await api.post(DELETE_MESSAGE, { ...payload });
};

export const getNewMessageCount = async (payload: any) => {
  return await api.get(GET_NEW_MESSAGE_COUNT);
};
